import {Energy} from '../../../Domain/Energy';
import {round} from './Internal/round';

export function formatEnergy(energy: Energy | null): {formatted: string; unit?: string} {
    if (energy === null) {
        return {formatted: '-'};
    }
    if (energy.joules < 1000) {
        return {formatted: round(energy.joules, 2), unit: 'j'};
    }

    return {formatted: round(energy.joules / 1000, 2), unit: 'kj'};
}

export function formatAverageEnergy(energy: Energy | null): {formatted: string; unit?: string} {
    if (energy === null) {
        return {formatted: '-'};
    }
    if (energy.joules < 1000) {
        return {formatted: round(energy.joules, 2), unit: 'j'};
    }

    return {formatted: round(energy.joules / 1000, 2), unit: 'kj'};
}
